import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { GlobalService } from './global.service';

@Injectable({
  providedIn: 'root'
})
export class StreamService {
key: string = 'stream'

   constructor(public hs: HttpService, public gs: GlobalService) { }
    async add(value: any) {
      try {
        delete value.id;
        let response = await this.hs.post(`/${this.key}/add-${this.key}`, {}, value)
        return response;
      } catch (error: any) {
        throw error;
      }
    }
    async delete(id: number) {
      try {
        let response = await this.hs.delete(`/${this.key}/delete-${this.key}?id=` + id, {})
        return response;
      } catch (error: any) {
        throw error;
      }
    }
    async get(id: any) {
      try {
        let response = await this.hs.get(`/${this.key}/get-${this.key}?id=` + id, {})
        return response;
      } catch (error: any) {
        throw error;
      }
    }
    async get_list(filters: any) {
      try {
        let response = await this.hs.get(`/${this.key}/get-${this.key}-list`, filters)
        return response;
      } catch (error: any) {
        throw error;
      }
    }
    async update(id: any, value: any) {
      try {
        let response = await this.hs.post(`/${this.key}/update-${this.key}?id=` + id, {}, value)
        return response;
      } catch (error: any) {
        throw error;
      }
    }
}
